import { FC, useMemo } from "react";

import { CircleCommunitySidebar } from "shared/ui/sales-floor/circle/sidebar";

import { DialerCloseButton as CloseButton } from "@/components/shared/widgets/buttons/close-button";
import { WIDGETS, widgets } from "@/widgets/index";
import { useSalesFloorsSearchQueryParams } from "@/widgets/sales-floors/use-search-query-params";
import { useCircleAuthentication } from "@/hooks/use-circle-authentication";

interface WidgetSalesFloorsPropsI {
  salesFloorSlug?: string | null;
  salesFloorPostByURL?: string | null;
}

const COMMUNITY_URL = process.env.NEXT_PUBLIC_CIRCLE_COMMUNITY_URL as string;

const handleCloseSalesFloor = () => {
  widgets.close({
    id: WIDGETS.SALES_FLOORS,
  });
};

export const WidgetSalesFloors: FC<WidgetSalesFloorsPropsI> = ({
  salesFloorSlug,
  salesFloorPostByURL,
}) => {
  useSalesFloorsSearchQueryParams();

  const accessToken = useCircleAuthentication();

  // There are three versions of the default community widget state:
  // 1) If a concrete post url is available, open this post by the absolute URL
  // 2) If a space slug is available, open this space (adding to the community URL)
  // 3) If none of the above is relevant, just show a feed aka "homepage"
  const circleIframeURL = useMemo(() => {
    if (salesFloorPostByURL) {
      return salesFloorPostByURL;
    }

    return salesFloorSlug
      ? `${COMMUNITY_URL}/c/${salesFloorSlug}`
      : COMMUNITY_URL;
  }, [salesFloorSlug, salesFloorPostByURL]);

  if (accessToken === null) {
    return null;
  }

  return (
    <CircleCommunitySidebar
      accessToken={accessToken}
      urlToDisplay={circleIframeURL}
      communityURL={COMMUNITY_URL}
      closeButton={CloseButton}
      onClose={handleCloseSalesFloor}
    />
  );
};
